import React, { memo } from 'react';

const OpportunitiesIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M3.2 6.4h6.4v-1.6c0-1.776 1.424-3.2 3.2-3.2h6.4c1.776 0 3.2 1.424 3.2 3.2v1.6h6.4c1.76 0 3.2 1.44 3.2 3.2v4.8c0 1.76-1.44 3.2-3.2 3.2h-4.8v-3.2h-3.2v3.2h-9.6v-3.2h-3.2v3.2h-4.8c-1.776 0-3.2-1.424-3.2-3.2v-4.8c0-1.76 1.44-3.2 3.2-3.2zM8 22.4v-3.2h-6.384l-0.016 8c0 1.776 1.424 3.2 3.2 3.2h22.4c1.776 0 3.2-1.424 3.2-3.2v-8h-6.4v3.2h-3.2v-3.2h-9.6v3.2h-3.2zM12.8 4.8v1.6h6.4v-1.6h-6.4z"
        />
    </svg>
);

export default memo(OpportunitiesIcon);
